// API Configuration
export const EXECUTE_URL = "/m4ai/api/v1/agent-systems/testgapanalysis/execute?version=7";

// Queries
export const TESTCASE_QUERY = "Tell me gaps in the current testing of the function Smart home and fill these gaps. Therefore I want you to analyse the function and connected testcases, requirements, jira-tickets. In this case, no matter what the system prompt states your goal is it to find exact 6 gaps and return 6 new testcases. It is very improtant that you find and create 6 new testcases";
export const REVIEWS_QUERY = "Analyse the bosch.rezensionen and the existing testcases. Improve the esisting testing with the rezensionen.";

// UI Constants
export const TEXTAREA_CONFIG = {
  MAX_LINES: 8,
  LINE_HEIGHT: 24,
  get MAX_HEIGHT() { return this.MAX_LINES * this.LINE_HEIGHT; }, // 192px
  MIN_HEIGHT: '3rem'
};

// Animation Timings
export const ANIMATION_DURATIONS = {
  ROBOT_PRINT_DELAY: 25, // ms between lines when printing robot code
  STATE_RESET_DELAY: 50   // ms delay for state updates to complete
};

// Panel IDs
export const PANEL_IDS = {
  ANALYSIS: 'analysis',
  TESTCASES: 'testcases',
  ROBOT: 'robot'
};